module.exports = __webpack_public_path__ + "static/media/Logo_joguejunto_Horizontal-03.bd56079b.svg";